import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";


// export const getFechasCuentasPorPagar = async (Fechas) => {
//     const result = await PrivateInterceptor(`CXP/CuentasPorPagar/fechas`, 'POST', { FechaInicio: Fechas[0], FechaFinal: Fechas[1] });
//     return result;
// }


export const postRegistroCuentasPorPagar = async (informacion) => {
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/IUCXP`, 'POST', informacion);
    return result;
}


export const postEstadoDetallesCuentasPorPagar = async (detalles) => {
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/EstadoDetalles`, 'POST', { Detalles: detalles });
    return result;
}

export const getEncabezadoCuentasPorPagar = async (Id) => {
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/Encabezado/${Id}`, 'GET');
    return result;
}

export const getDetallesCuentasPorPagar = async (Id) => {
const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/Detalles/${Id}`, 'GET');
    return result;
}

export const getUltimoIdEncabezadoCXP = async () => {
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/UltimoId`, 'GET');
    return result;
}

export const getFechasCuentasPorPagarDetalles = async (Fechas) => {
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/FechasDetalles`, 'POST', { FechaInicio: Fechas[0], FechaFinal: Fechas[1] });
    return result;
}

export const postEliminarIngresoDeCuentasPorPagar = async(informacion) => {
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/EliminarIngreso`, 'POST', informacion);
    return result;
}

export const getDetallesIngresos = async(informacion) =>{
    
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/DetallesIngreso`, 'POST', informacion);
    return result;
}

export const getInformacionEncabezadoCXP = async(informacion)=>{
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/InformacionEnc`, 'POST', informacion);
    return result;
}

export const getFechasFacturasManuales = async (Fechas) => {
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/FechasFacturasManuales`, 'POST', { FechaInicio: Fechas[0], FechaFinal: Fechas[1] });
    return result;
}

export const postEncabezadoConsolidado = async(Encabezado) =>{
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/ActualizarConsolidadoEnc`, 'POST', { Encabezado: Encabezado });
    return result;
}

export const postEncabezadoConsolidadoInv = async(Informacion) =>{
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/ActualizarEncabezadosInv`, 'POST', Informacion);
    return result;
}

export const postEstadoFinazasRegistros = async(data) =>{
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/EstadoFinanzasEnc`, 'POST', {Encabezado: data});
    return result;
}


export const postIUEncabezadoConsolidadoInv = async(Informacion) =>{
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/IUConsolidadoCXP`, 'POST', Informacion);
    return result;
}

export const getFechasFacturasMateriaPrima = async (Fechas) => {
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/FechasFacturasMateriaPrima`, 'POST', { FechaInicio: Fechas[0], FechaFinal: Fechas[1] });
    return result;
}

export const getFechasDetallesMateriaPrima= async (Fechas) => {
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/FechasDetallesMateriaPrima`, 'POST', { FechaInicio: Fechas[0], FechaFinal: Fechas[1] });
    return result;
}

export const getFechasComprasFacturasManuales = async (Fechas) => {
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/FechasComprasFacturasManuales`, 'POST', { FechaInicio: Fechas[0], FechaFinal: Fechas[1] });
    return result;
}

export const getFechasDetallesCompras= async (Fechas) => {
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/FechasDetallesCompras`, 'POST', { FechaInicio: Fechas[0], FechaFinal: Fechas[1] });
    return result;
}


export const getVerificacionFactura =  async(Informacion) =>{
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/VerificacionFactura`, 'POST', Informacion);
    return result;
}

export const getDocumentosFactura =  async(IdFactura) =>{
    const result = await PrivateInterceptor(`Base/CuentasPorPagar/CXP/MovimientosFactura`, 'POST', {IdFactura});
    return result;
}





// export const postPagarFacturasConsolidado = async(Encabezado) =>{
//     const result = await PrivateInterceptor(`CXP/CuentasPorPagar/PagarFacturasConsolidado`, 'POST', { Encabezado: Encabezado });
//     return result;
// }


// export const postEliminarEncabezadoCXP = async(Encabezado) =>{
//     const result = await PrivateInterceptor(`CXP/CuentasPorPagar/EliminarEncabezado`, 'POST', { Encabezado: Encabezado });
//     return result;
// }

// export const CuentasTransitoProveedor = async (IdPO) => {
//     const result = await PrivateInterceptor(`CXP/CuentasPorPagar/CuentasTransitoProveedor/${IdPO}`, 'GET');
//     return result;
// }

// export const getIngresoCuentaTransito = async(IdCuentaTransito) =>{
//     const result = await PrivateInterceptor(`CXP/CuentasPorPagar/IngresoCuentaTransito/`, 'POST', {IdCuentaTransito});
//     return result;
// }
 